<template>
  <slot />
</template>

<script setup lang="ts">
import {
  NativeAppEvents,
  NativeAppMessage,
} from "@tableyeti/webview-messages/src/events/native-app";
import { onBeforeUnmount, onMounted } from "vue";
import { setBasecampIsLoaded } from "@/utils/native-app-webview";

const { autoSetIsLoaded = true } = defineProps<{ autoSetIsLoaded?: boolean }>();

onMounted(() => {
  if (autoSetIsLoaded) {
    setBasecampIsLoaded();
  }
  window.addEventListener("message", (message) => handleCompanionMessage(message.data));
});

onBeforeUnmount(() => {
  window.removeEventListener("message", (message) => handleCompanionMessage(message.data));
});

const emit = defineEmits<{
  (e: "received-message", message: NativeAppMessage): void;
}>();

const handleCompanionMessage = (message: string) => {
  const parsedMessage = JSON.parse(message) as NativeAppMessage;

  if (parsedMessage.event !== NativeAppEvents.TokensRefreshed) {
    emit("received-message", parsedMessage);
  }
};
</script>
